export default {
  CEP: axios.create({
    baseURL: process.env.VUE_APP_ENDPOINT_API + "cep"
  })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/CEP.js
// module id = QJK6
// module chunks = 32